import React, { useMemo, useState, useEffect } from 'react';
import { TIPS } from './tips';

function clampIdx(idx, length) {
  if (length <= 0) return 0;
  const m = idx % length;
  return m < 0 ? m + length : m;
}

export default function TipsCarousel({ tips, locale }) {
  const items = useMemo(() => Array.isArray(tips) ? tips : [], [tips]);
  const [idx, setIdx] = useState(0);

  // Auto-rotate tips every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
        setIdx(v => v + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const current = items[clampIdx(idx, items.length)];
  if (!current) return null;

  const lang = locale && locale.startsWith('fr') ? 'fr' : 'en';
  const title = current.title?.[lang] || current.title?.en || '';
  const body = current.body?.[lang] || current.body?.en || '';

  return (
    <div className="w-full mt-6 mb-6">
      <div className="rounded-xl border border-gray-100 bg-blue-50/50 overflow-hidden shadow-sm">
        <div className="px-6 py-4 border-b border-blue-100 bg-blue-50 flex justify-between items-center">
          <div className="text-xs font-bold text-blue-600 tracking-wide uppercase flex items-center gap-2">
            <span className="text-lg">💡</span> DID YOU KNOW?
          </div>
          <div className="text-xs text-blue-400 font-mono">
             {items.length > 0 ? `${clampIdx(idx, items.length) + 1}/${items.length}` : ''}
          </div>
        </div>

        <div className="px-6 py-5 text-left">
          <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
          <p className="text-gray-700 leading-relaxed text-base">{body}</p>
        </div>

        {/* Navigation dots */}
        <div className="px-6 pb-4 flex justify-center gap-2">
            {items.map((_, i) => (
                <button
                  key={i}
                  className={`h-1.5 rounded-full transition-all duration-300 ${i === clampIdx(idx, items.length) ? 'w-6 bg-blue-500' : 'w-1.5 bg-blue-200'}`}
                  onClick={() => setIdx(i)}
                />
            ))}
        </div>
      </div>
    </div>
  );
}


